
import Vue from "vue";
import types from "./store/types";
import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";
import { PlaceSetting } from "./place-setting";
import { MonitorSetting } from "./monitor-setting";
import { MonitorIdHashDefault } from "@/monitor-id";
import PC from "./components/pc.vue";
import SP from "./components/sp.vue";
import { postMonitorHealth } from "./api";

export default Vue.extend({
  name: "App",
  components: {
    PC,
    SP,
  },
  data() {
    return {
      currentLanguage: "ja",
      logInterval: -1,
      monitorSetting: MonitorSetting,
      monitorIdHashDefault: MonitorIdHashDefault,
    };
  },
  computed: {
    currentEnv(): string {
      const host = window.location.host;
      if (host.includes("localhost")) {
        return "development";
      } else if (host.includes("development")) {
        return "development";
      } else if (host.includes("staging")) {
        return "staging";
      } else {
        return "production";
      }
    },
    placeIdHashList(): string[] {
      return PlaceSetting[this.currentEnv] ?? [""];
    },
    vacancy(): (placeIdHash: string) => SignageAdapterApi.ResponseGetDisplayVacancy | undefined {
      return this.$store.getters["place/vacancyByPlaceIdHash"];
    },
    floorPlan() {
      return [...this.$store.state.place.floorPlan];
    },
    gender(): (placeIdHash: string) => SignageAdapterApi.ResponseGetDisplayVacancy | undefined {
      return this.$store.getters["place/genderByPlaceIdHash"];
    },
    areaGenderList() {
      return [...this.$store.state.place.areaGenderList];
    },
    monitorIdHash():string{
      let url:string = location.href;
      for(let item of this.monitorSetting){
        if(url.indexOf(item[2]) > -1){
         return item[2];
        }
      }
      return this.monitorIdHashDefault;
    },
    monitorProps():string[]{
       let ms:string[] = this.monitorSetting[0];
       for(let item of this.monitorSetting){
           if(item[2] == this.monitorIdHash){
               ms = item;
           }
       }
       return ms;
    },
  },
  methods: {
    currentUnixtime(): number {
      return Math.floor(Date.now() / 1000);
    },
    urlQuery() {
      return new URLSearchParams(window.location.search);
    },
    positionConfirm():void{
      //his.$refs;
      //this.$refs.currentPoints.confirmPosition();
    },
  },
  mounted: function(){
    //console.log(this.monitorProps);
  },
  async created() {
    await this.$store.dispatch(`place/${types.place.actions.SETUP}`, {
      placeIdHashList: this.placeIdHashList,
    });
    await this.$store.dispatch(`place/${types.place.actions.LOOP}`, {
      placeIdHashList: this.placeIdHashList,
    });

    /**
     * Log metrics for signage health
     * @value firstVacancyMutationTime は画面起動時の時刻
     * @value latestVacancyMutationTime はhealthを飛ばす瞬間の時刻
     * として利用する
     */
    let firstVacancyMutationTime = this.currentUnixtime();
    const logLevel = this.urlQuery().get("logLevel");
    if (logLevel === "info") {
      this.logInterval = window.setInterval(() => {
        postMonitorHealth({
          monitorId: parseInt(this.monitorProps[1]),
          areaName: "あなぶきアリーナサイネージ",
          contentType: "one_time_only",
          firstVacancyMutationUnixtime: firstVacancyMutationTime,
          latestVacancyMutationUnixtime: this.currentUnixtime(),
          unixtime: this.currentUnixtime(),
          userAgent: window.navigator.userAgent,
        });
      }, 30000);
    }
  },
  async beforeDestroy() {
    await this.$store.dispatch(`place/${types.place.actions.TEARDOWN}`);
    clearInterval(this.logInterval);
  },
});
